<footer class="footer d-flex text-center text-sm-start fixed-bottom w-100 bg-light shadow-lg">
  <div class="container-xxl">
    <div class="row justify-content-between py-1 px-2">

      <!-- HOME -->
      <div class="col-auto text-center p-0 cursor-pointer" [routerLink]="userInfo?.type == 1 
          ? '/user/home' 
          : userInfo?.type == 2 
            ? '/subagent/home' 
            : '/regional-manager/home'">

        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.3" [attr.color]="isHomeActive 
              ? '#2baae2' 
              : (theme$ | async) === 'light' ? '#363636' : '#ffffff'" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icon-tabler-home">

            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
            <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
            <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
          </svg>
        </div>

        <div>
          <span class="fs-11 fw-light d-block d-sm-none" [class.text-primary-blue]="isHomeActive"
            [class.text-dark]="!isHomeActive">
            {{ 'home' | translate }}
          </span>

          <span class="fs-6 fw-light d-none d-sm-block" [class.text-primary-blue]="isHomeActive"
            [class.text-dark]="!isHomeActive">
            {{ 'home' | translate }}
          </span>
        </div>
      </div>

      <!-- TRANSACTIONS -->
      <div class="col-auto text-center p-0 cursor-pointer" [routerLink]="userInfo?.type == 1 
          ? '/user/transactions' 
          : userInfo?.type == 2 
            ? '/subagent/transactions' 
            : '/regional-manager/transactions'">

        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.3" [attr.color]="isTransactionsActive 
              ? '#2baae2' 
              : (theme$ | async) === 'light' ? '#363636' : '#ffffff'" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icon-tabler-cash-banknote">

            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
            <path d="M3 8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
            <path d="M18 12h.01" />
            <path d="M6 12h.01" />
          </svg>
        </div>

        <div>
          <span class="fs-11 fw-light d-block d-sm-none" [class.text-primary-blue]="isTransactionsActive"
            [class.text-dark]="!isTransactionsActive">
            {{ 'transactions' | translate }}
          </span>

          <span class="fs-6 fw-light d-none d-sm-block" [class.text-primary-blue]="isTransactionsActive"
            [class.text-dark]="!isTransactionsActive">
            {{ 'transactions' | translate }}
          </span>
        </div>
      </div>

      <!-- QR -->
      <div class="col-auto text-center p-0 cursor-pointer"
        (click)="openModal(exampleModalCenter, { centered: true, size: 'sm' })">

        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.3" [attr.color]="(theme$ | async) === 'light' ? '#363636' : '#ffffff'"
            stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icon-tabler-qrcode">

            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
            <path d="M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
            <path d="M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
            <path d="M14 14l3 0" />
            <path d="M14 14l0 3" />
            <path d="M14 20l3 0" />
          </svg>
        </div>

        <div>
          <span class="fs-11 fw-light d-block d-sm-none text-dark">{{ 'QR' | translate }}</span>
          <span class="fs-6 fw-light d-none d-sm-block text-dark">{{ 'QR' | translate }}</span>
        </div>
      </div>

      <!-- CALCULATOR -->
      <div class="col-auto text-center p-0 cursor-pointer" [routerLink]="userInfo?.type == 1 
          ? '/user/calculator' 
          : userInfo?.type == 2 
            ? '/subagent/calculator' 
            : '/regional-manager/calculator'">

        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.3" [attr.color]="isCalculatorActive 
              ? '#2baae2' 
              : (theme$ | async) === 'light' ? '#363636' : '#ffffff'" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icon-tabler-calculator">

            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 3m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
            <path d="M8 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
            <path d="M8 14l0 .01" />
            <path d="M12 14l0 .01" />
            <path d="M16 14l0 .01" />
          </svg>
        </div>

        <div>
          <span class="fs-11 fw-light d-block d-sm-none" [class.text-primary-blue]="isCalculatorActive"
            [class.text-dark]="!isCalculatorActive">
            {{ 'calculator' | translate }}
          </span>

          <span class="fs-6 fw-light d-none d-sm-block" [class.text-primary-blue]="isCalculatorActive"
            [class.text-dark]="!isCalculatorActive">
            {{ 'calculator' | translate }}
          </span>
        </div>
      </div>

      <!-- USER -->
      <div class="col-auto text-center p-0 cursor-pointer" [routerLink]="userInfo?.type == 1 
          ? '/user/user' 
          : userInfo?.type == 2 
            ? '/subagent/user' 
            : '/regional-manager/user'">

        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.3" [attr.color]="isUserActive 
              ? '#2baae2' 
              : (theme$ | async) === 'light' ? '#363636' : '#ffffff'" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icon-tabler-user-circle">

            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
          </svg>
        </div>

        <div>
          <span class="fs-11 fw-light d-block d-sm-none" [class.text-primary-blue]="isUserActive"
            [class.text-dark]="!isUserActive">
            {{ 'user' | translate }}
          </span>

          <span class="fs-6 fw-light d-none d-sm-block" [class.text-primary-blue]="isUserActive"
            [class.text-dark]="!isUserActive">
            {{ 'user' | translate }}
          </span>
        </div>
      </div>

    </div>
  </div>
</footer>

<!-- MODAL -->
<ng-template #exampleModalCenter let-modal>
  <div class="modal-body text-center">
    <h1 class="text-dark-blue">{{ 'accountQrCode' | translate }}</h1>
    <h5>{{ 'useQrCodeForTransactions' | translate }}</h5>
    <hr class="my-2">

    <qrcode #qrCode [qrdata]="userQrCode()" [width]="256" [errorCorrectionLevel]="'M'" elementType="canvas">
    </qrcode>
  </div>

  <div class="modal-footer d-flex justify-content-between">
    <button type="button" class="btn btn-outline-light btn-sm" (click)="modal.dismiss()">
      {{ 'close' | translate }}
    </button>

    <button type="button" class="btn btn-primary-blue btn-sm" (click)="shareQr(modal)">
      {{ 'share' | translate }}
    </button>
  </div>
</ng-template>